import { ExtendedPart } from "../types";
import { isJobProcessing } from "./isJobProcessing";

export const isPartBeingAnalyzed = (part: ExtendedPart): boolean =>
  isJobProcessing(part.analyzeStatus) ||
  isJobProcessing(part.analyze2DStatus) ||
  isJobProcessing(part.graphStatus) ||
  isJobProcessing(part.featuresStatus);
